import { Client } from 'openapi-fetch'

import type { paths } from '@kidzonet/ts-api-generator/clients/dashboard'

declare global {
    // eslint-disable-next-line vars-on-top
    var DashboardApiClient: Client<paths>
}

export const fetchPerBlockedCatActivity = async () => {
    const { data, error } = await globalThis.DashboardApiClient.GET(
        '/v1/public/dashboard/dns_log/activity', {
            params: {
                query: { status: 'BLOCKED' },
            },
        },
    )

    if (error) {
        throw error
    }
    const { items = [] } = data
    return items.map(
        item => ({ catId: item.cat_id || 0, requestsCount: item.requests_count }),
    )
}
